import React from 'react';

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
  onClick,
  type = 'button',
  fullWidth = false,
  component: Component = 'button',
  ...props
}) => {
  const baseClasses = 'inline-flex items-center justify-center gap-2 font-medium rounded-2xl transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    primary: 'btn-primary-teal focus:ring-primary/50',
    secondary: 'bg-surface dark:bg-surface-dark text-primary dark:text-primary-dark border-2 border-primary dark:border-primary hover:bg-primary/5 dark:hover:bg-primary/10 focus:ring-primary/50',
    outline: 'bg-transparent text-primary dark:text-primary-dark border-2 border-primary dark:border-primary hover:bg-primary/10 dark:hover:bg-primary/10 focus:ring-primary/50',
    ghost: 'bg-transparent text-primary dark:text-primary-dark hover:bg-primary/10 dark:hover:bg-primary/10 focus:ring-primary/50',
    danger: 'bg-error text-white hover:bg-error/90 focus:ring-error/50',
    success: 'bg-success text-white hover:bg-success/90 focus:ring-success/50',
  };

  const sizes = {
    sm: 'px-3 py-1.5 text-xs sm:px-4 sm:py-2 sm:text-sm',
    md: 'px-4 py-2 text-sm sm:px-6 sm:py-3 sm:text-base',
    lg: 'px-6 py-3 text-base sm:px-8 sm:py-4 sm:text-lg',
    xl: 'px-8 py-4 text-lg sm:px-10 sm:py-5 sm:text-xl',
  };

  const classes = `${baseClasses} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;

  // If component is not 'button', we should not pass 'type' or 'disabled' as attributes
  // unless we are sure the receiving component handles them.
  const componentProps = Component === 'button' ? { type, disabled: disabled || loading, ...props } : props;

  return (
    <Component
      className={classes}
      onClick={onClick}
      {...componentProps}
    >
      {loading ? (
        <div className="flex items-center justify-center">
          <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin mr-2"></div>
          Loading...
        </div>
      ) : (
        children
      )}
    </Component>
  );
};

export default Button;
